"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configurations = void 0;
const client_1 = require("@arkecosystem/client");
class Configurations extends client_1.Resource {
    async index() {
        return this.sendGet("nft/exchange/configurations");
    }
}
exports.Configurations = Configurations;
//# sourceMappingURL=configurations.js.map